'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ICE: 'ICE',
  PEGGER: 'PEGGER',
  POV: 'POV',
  PVWAP: 'PVWAP',
  SOR: 'SOR',
  SPREAD: 'SPREAD',
  SVWAP: 'SVWAP',
  TWAP: 'TWAP',
  VWAP: 'VWAP',
  FOE: 'FOE' };